import { MenuNavComponent } from './shared/Components/menu-nav/menu-nav.component';
import { DataDocumentsComponent } from '../app/components/profile/data-documents/data-documents.component';
import { DataVehicleComponent } from '../app/components/profile/data-vehicle/data-vehicle.component';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpBackend, HttpClient, HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { GoogleMapsModule } from '@angular/google-maps';
import { GlobalErrorHandler } from './core/global-error-handler';
import { ErrorHandler } from '@angular/core';
import { CountUpModule } from 'ngx-countup';
// Routes
import { routes } from './app.route';

import { AppComponent } from './app.component';

// Store
import { StoreModule } from '@ngrx/store';
import { indexReducer } from './store/index.reducer';

// Shared module
import { SharedModule } from 'src/shared.module';
// i18n
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
// AOT compilation support
export function HttpLoaderFactory(httpHandler: HttpBackend): TranslateHttpLoader {
  return new TranslateHttpLoader(new HttpClient(httpHandler));
}

// Dashboard
import { IndexComponent } from './index';

// Layouts
import { HomeLayout } from './layouts/home-layout';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';

import { HeaderComponent } from './layouts/header';
import { FooterComponent } from './layouts/footer';
import { SidebarComponent } from './layouts/sidebar';
import { ThemeCustomizerComponent } from './layouts/theme-customizer';

// Components module
import { ComponentsModule } from './components/components.module';

//error 404
import { Error404Component } from './shared/Components/error404/error404.component';

// Services
import { GeolocationService } from './shared/service/geolocation/geolocation.service';
import { AuthService } from './shared/service/auth/auth.service';
import { CommonService } from './shared/service/common/common.service';
import { AlertService } from './shared/service/common/alert.service';
import { CoverLoginComponent } from './core/auth/login/login.component';
import { AssistantComponent } from './components/assistant/assistant.component';
import { environment } from '../environments/environment';
import { CoverRegisterComponent } from './core/auth/register/register.component';
import { ConfirmationmessageComponent } from './shared/Components/comfirmation-message/comfirmation-message.component';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAnalytics, provideAnalytics, ScreenTrackingService } from '@angular/fire/analytics';
import { LanguajesComponent } from './shared/Components/languajes/languajes.component';
// import { NetworksComponent } from './shared/Components/networks/networks.component';
import { ProfileComponent } from '../app/components/profile/profile.component';
import { EditProfileComponent } from '../app/components/edit-profile/edit-profile.component';
import { DocumentationComponent } from '../app/components/edit-profile/documentation/documentation/documentation.component';
import { VehicleComponent } from '../app/components/vehicle/vehicle/vehicle.component';
import { HomeProfileComponent } from '../app/components/edit-profile/home/home-profile/home-profile.component';
import { FinesComponent } from '../app/components/profile/fines/fines.component';
import { HomeComponent } from './components/home/home.component';
import { TestimonyComponent } from './shared/Components/testimony/testimony.component';
import { CalendarComponent } from './components/calendar/calendar';
// modal
import { NgxCustomModalComponent } from 'ngx-custom-modal';

// fullcalendar
import { FullCalendarModule } from '@fullcalendar/angular';
import { CounterComponent } from './shared/Components/counter/counter.component';
import { AlertsComponent } from './shared/Components/alerts/alerts/alerts.component';
import { HomeAlertsComponentAlert } from './shared/Components/alerts/home/home.component';
import { PlatecityComponent } from './shared/Components/alerts/platecity/platecity/platecity.component';
import { OdsComponent } from '../app/components/profile/ods/ods.component';
import { AddVehicleComponent } from './components/crud-vehicle-module-cars/add-vehicle/add-vehicle.component';
import { ListVehicleComponent } from './components/crud-vehicle-module-cars/list-vehicle/list-vehicle.component';
import { DataTableModule } from '@bhplugin/ng-datatable';
import { EditVehicleComponent } from './components/crud-vehicle-module-cars/edit-vehicle/edit-vehicle.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { ModalVehicleEditComponent } from './components/crud-vehicle-module-cars/modal-vehicle-edit/modal-vehicle-edit.component';
import { RegisterNumberEmailComponent } from './shared/Components/register-number-email/register-number-email.component';
import { ServiceCenterFormComponent } from './components/register-main/service-center-form/service-center-form.component';
import { AccessHomeComponent } from './components/access-home/access-home.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { PanelStartComponent } from './components/profile/panel-start/panel-start.component';
import { RegisterMainComponent } from './components/register-main/register-main.component';
import { AssistantAiComponent } from './shared/Components/assistant-ai/assistant-ai.component';
import { NotificationsComponent } from './shared/Components/notifications/notifications.component';
import { CommunityComponent } from './shared/Components/community/community.component';
import { HomeDiscoverComponent } from './components/home-discover/home-discover.component';
import { ManageVehiclesComponent } from './components/manage-vehicles/manage-vehicles.component';
import { VehicleAnalyticsComponent } from './components/vehicle-analytics/vehicle-analytics.component';
import { NgApexchartsModule } from 'ng-apexcharts';
// Fleet module (Command Center + 360 Profile + Analytics)
import { Vehicle360ProfileComponent } from './components/fleet/vehicle-360-profile/vehicle-360-profile.component';
import { MaintenanceTimelineComponent } from './components/fleet/vehicle-360-profile/maintenance-timeline/maintenance-timeline.component';
import { FleetCommandCenterComponent } from './components/fleet/fleet-command-center/fleet-command-center.component';
import { LiveMapWidgetComponent } from './components/fleet/fleet-command-center/live-map-widget/live-map-widget.component';
import { FleetSidePanelComponent } from './components/fleet/fleet-command-center/fleet-side-panel/fleet-side-panel.component';
import { VehicleMiniCardComponent } from './components/fleet/fleet-command-center/vehicle-mini-card/vehicle-mini-card.component';
import { FleetAnalyticsDashboardComponent } from './components/fleet/fleet-analytics-dashboard/fleet-analytics-dashboard.component';
import { VehicleAnalyticsPanelComponent } from './components/fleet/fleet-analytics-dashboard/vehicle-analytics-panel/vehicle-analytics-panel.component';

const config: SocketIoConfig = { url: environment.socketUrl, options: {} };

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    NgOptimizedImage,
    FormsModule,
    DataTableModule,
    ComponentsModule,
    HttpClientModule,
    NgScrollbarModule,
    CountUpModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    GoogleMapsModule,
    FullCalendarModule,
    NgxCustomModalComponent,
    NgSelectModule,
    NgApexchartsModule,
    SocketIoModule.forRoot(config),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend],
      },
    }),
    StoreModule.forRoot({ index: indexReducer }),
    SharedModule.forRoot(),
  ],
  declarations: [
    HomeComponent,
    AppComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    ThemeCustomizerComponent,
    IndexComponent,
    HomeLayout,
    CoverLoginComponent,
    CoverRegisterComponent,
    AssistantComponent,
    Error404Component,
    ConfirmationmessageComponent,
    CounterComponent,
    // NetworksComponent,
    TestimonyComponent,
    LanguajesComponent,
    ProfileComponent,
    EditProfileComponent,
    DocumentationComponent,
    VehicleComponent,
    HomeProfileComponent,
    OdsComponent,
    FinesComponent,
    DataVehicleComponent,
    DataDocumentsComponent,
    CalendarComponent,
    AlertsComponent,
    HomeAlertsComponentAlert,
    PlatecityComponent,
    AddVehicleComponent,
    ListVehicleComponent,
    EditVehicleComponent,
    ModalVehicleEditComponent,
    RegisterNumberEmailComponent,
    HomeComponent,
    ServiceCenterFormComponent,
    AccessHomeComponent,
    PanelStartComponent,
    RegisterMainComponent,
    AssistantAiComponent,
    NotificationsComponent,
    MenuNavComponent,
    CommunityComponent,
    HomeDiscoverComponent,
    ManageVehiclesComponent,
    VehicleAnalyticsComponent,
    Vehicle360ProfileComponent,
    MaintenanceTimelineComponent,
    FleetCommandCenterComponent,
    LiveMapWidgetComponent,
    FleetSidePanelComponent,
    VehicleMiniCardComponent,
    FleetAnalyticsDashboardComponent,
    VehicleAnalyticsPanelComponent,
  ],
  providers: [
    Title,
    GeolocationService,
    AuthService,
    CommonService,
    AlertService,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    provideFirebaseApp(() => initializeApp(environment.firabase)),
    provideAnalytics(() => getAnalytics()),
    ScreenTrackingService,
  ],
  //   entryComponents: [EditVehicleComponent],
  bootstrap: [AppComponent],
  exports: [SharedModule, FullCalendarModule, NgxCustomModalComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
